import React from "react";
import "./pages/Admin.css";
import { NavLink, useNavigate } from "react-router-dom";
import navlogo from "../../assets/img/Admin/vas-logo1-nav2.png";

function AdminNavbar({ toggle }) {
  const navigate = useNavigate();

  const userName = localStorage.getItem("name");
  const UserRole = localStorage.getItem("role");

  const navigatehandle = () => {
    navigate("/projectreport");
  };
  const navigatehandleinvoice = () => {
    navigate("/invoice");
  };
  const haldlenavigatedashboard = () => {
    navigate("/dashboard");
  };
  return (
    <nav className="navbar default-layout-navbar col-lg-12 p-0 fixed-top d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <div className="navbar-brand brand-logo">
          <img
            onClick={haldlenavigatedashboard}
            src={navlogo}
            style={{ width: "auto", height: "68px" }}
            alt="logo"
          />
        </div>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-stretch">
        <div className="mx-5 responsive-none">
          <p className="navbarroutertag" onClick={navigatehandle}>
            Projects
          </p>
        </div>
        {UserRole !== "editor" && (
          <div className="responsive-none">
            <p className="navbarroutertag" onClick={navigatehandleinvoice}>
              Invoice
            </p>
          </div>
        )}
        <ul className="navbar-nav navbar-nav-right responsive-none">
          <li className="nav-item">
            <i className="fa-regular fa-circle-user usericon mx-2"></i>
            <b className="admin-username-nav">
              {userName} -{" "}
              {UserRole.charAt(0).toUpperCase() + UserRole.slice(1)}
            </b>
          </li>
        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          onClick={toggle}
        >
          <i className="fa-solid fa-bars"></i>
        </button>
      </div>
    </nav>
  );
}

export default AdminNavbar;
